module.exports = __webpack_public_path__ + "static/img/son4.bebe20b3.png";